export const DEVICE = {
  DESKTOP: "d",
  MOBILE: "m",
};